import { LogicalDeleteDTO } from '../basic/logicalDeleteDTO';
import { CollaboratoreDTO } from '../domain/collaboratore';

export class AssenzaRapportinoDTO extends LogicalDeleteDTO {
    collaboratore: CollaboratoreDTO;
    tipo: string;
    dataPresenza: Date; // Attributo chiamato in questo modo per avere una gestione più rapida del sort
    numeroDiOre: number;
    oreCensite: number;
}